/**
 * Утилиты для работы с данными полей напрямую из newData
 */

export interface FieldData {
  field: any;
  value: any;
  data: any;
  get: (property: string) => any;
  set: (property: string, value: any) => void;
}

/**
 * Создает объект FieldData из поля
 */
function createFieldData(field: any): FieldData {
  return {
    field: field,
    value: field.data?.value || null,
    data: field.data || null,
    get: (property: string) => field.data?.[property] || null,
    set: (property: string, value: any) => {
      if (field.data) {
        field.data[property] = value;
      }
    }
  };
}

/**
 * Получает поле по пути из данных блока
 */
export function getFieldFromData(path: string, blockData: any): FieldData | null {
  if (!blockData || !blockData.fieldsGroups) return null;
  
  const pathParts = path.split('.');
  
  // Все поля должны быть в группах
  if (pathParts.length !== 2) return null;
  
  const [groupName, fieldName] = pathParts;
  const group = blockData.fieldsGroups.find((group: any) => 
    group?.name === groupName
  );
  
  if (!group || !group.fields) return null;
  
  const field = group.fields.find((f: any) => f.name === fieldName);
  if (!field) return null;
  
  return createFieldData(field);
}

/**
 * Получает свойство поля по пути из данных блока
 */
export function getFieldProperty(path: string, property: string, blockData: any): any {
  const field = getFieldFromData(path, blockData);
  return field?.get(property) || null;
}
